<template>
  <!-- 按钮背景
       @author: liuguisheng
       @date: 2019-9-21
   -->
  <div class="setting-item">
    <el-form-item label="节流时间"> 
        <el-select v-model="buttonThrottle" placeholder="请选择">
            <el-option v-for="item in buttonThrottleList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
            </el-option>
        </el-select>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听文件
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import {mapComputed} from '@/mixins/common/mix_value_watch.js';
// 导入节流时间配置数组
import { buttonThrottleList } from '@/assets/js/config_dictionary.js';
export default {
  mixins: [ mixValueWatch ],
  data () {
        return {
            // 节流时间配置数组
            buttonThrottleList
        }
  },
  computed: {
    /** @name 按钮loading效果
     *  @description 将 buttonThrottle 字段映射到当前 buttonThrottle 计算属性
     *  @return {String}
     *  @author liuguisheng
     *  @version 2019-09-21
     */
    ...mapComputed({
      buttonThrottle: { 
        parent: i => i.baseOption,
        attr: "buttonThrottle" 
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingButtonThrottle.vue